import { render, staticRenderFns } from "./Typeoperations_Headers.vue?vue&type=template&id=351e374c&"
import script from "./Typeoperations_Headers.vue?vue&type=script&lang=js&"
export * from "./Typeoperations_Headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports